import { DynamicLoaderRegistry } from '@tencent/workbench';
import { loadTask } from '@framework/workbench/common/service/tasks/load-task';
import { ReactElement } from 'react';

export interface IAnonymousViewFeature {
    getDescription: () => ReactElement;
    initAnonymousService: () => void;
}

export const IAnonymousViewFeature = Symbol.for('feature:anonymous-view');

DynamicLoaderRegistry.merge(IAnonymousViewFeature, {
    useFactory: async () => {
        const { AnonymousViewFeature } = await import('./anonymous-view-feature');
        return AnonymousViewFeature;
    },
    on: loadTask,
});

export async function loadAnonymousViewFeature(): Promise<IAnonymousViewFeature> {
    return await DynamicLoaderRegistry.get(IAnonymousViewFeature)?.getInstance();
}
